import clsx from 'clsx';
import { ReactNode } from 'react';

import { Icon } from '../icon';

import styles from './chip.module.scss';

export const Chip = (props: ChipProps) => {
  const { color = 'hero', icon, label, onClose, ...rest } = props;

  return (
    <div className={clsx(styles.chip, styles[`c-${color}`])} {...rest}>
      {icon}
      <span className="ellipsis-text" aria-label={label} title={label}>
        {label}
      </span>
      {typeof onClose === 'function' && <Icon size={14} type="cancel-01" onClick={onClose} data-testid="chip-close" />}
    </div>
  );
};

export interface ChipProps {
  label: string;
  icon?: ReactNode;
  onClose?: () => void;
  color?: 'hero' | 'secondary';
}
